import React from 'react';
import PropTypes from 'prop-types';
import { useEntitiesFulfillmentPlan } from '../../../hooks/entities/selectors/fulfillment-plans';

import { useSellerFormattedDate, useSellerFormattedTime, useIsMidnightInSellerTimeZone } from '../../../hooks/use-datetime-formats';

import { messages } from './messages';

const DeliverByColumn = ({ fulfillmentPlanId }) => {
  const { fulfillmentPlanDates } = useEntitiesFulfillmentPlan(fulfillmentPlanId);
  const dateValueUtc = fulfillmentPlanDates.deliverByDate;
  const formattedEntityDate = useSellerFormattedDate(dateValueUtc) ?? undefined;
  const formattedEntityTime = useSellerFormattedTime(dateValueUtc, true) ?? undefined;
  const isMidnightInSellerTimeZone = useIsMidnightInSellerTimeZone(dateValueUtc);
  const dateString = dateValueUtc && !isMidnightInSellerTimeZone ? `${formattedEntityDate} ${formattedEntityTime}` : formattedEntityDate;

  if (!dateValueUtc) {
    return '';
  }

  return dateString;
};

DeliverByColumn.propTypes = {
  fulfillmentPlanId: PropTypes.string.isRequired,
};

export const DeliverBy = {
  getMessageDescriptor: () => messages.deliverBy,
  id: 'deliver-by',

  render: (data) => {
    return <DeliverByColumn fulfillmentPlanId={data.id} />;
  },
};
